import { IconButton } from "@chakra-ui/react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { MenuContent, MenuRoot, MenuTrigger } from "@/components/ui/menu";
import type { WritingMetadataPublic } from "@/client";
import EditWritingMetadata from "./EditWritingMetadata";
import DeleteWriting from "./DeleteWriting";
import { Button } from "@chakra-ui/react";
import { FaCopy } from "react-icons/fa";

interface ActionsMenuWritingProps {
  writingMetadata: WritingMetadataPublic;
}

export const ActionsMenuWriting = ({
  writingMetadata,
}: ActionsMenuWritingProps) => {
  return (
    <MenuRoot>
      <MenuTrigger asChild>
        <IconButton
          variant="ghost"
          color="inherit"
          size="sm"
          aria-label="Open writing actions"
        >
          <BsThreeDotsVertical />
        </IconButton>
      </MenuTrigger>
      <MenuContent>
        <EditWritingMetadata writingMetadata={writingMetadata} />

        <Button variant="ghost" size="sm" colorPalette="red">
          <FaCopy fontSize="16px" />
          메모 복제
        </Button>

        <DeleteWriting id={writingMetadata.writing_id} />
      </MenuContent>
    </MenuRoot>
  );
};
